import * as React from "react";
import thinImage from "../images/icon_wms.png";
import iotImage from "../images/icon_EDM.png";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface cardDetails {
  name: string,
  url: string,
  desc: string,
  imgUrl: string,
  class: string
}

const Content = () => {
  const { t } = useTranslation("common");

  const navigate = useNavigate();

  // const cards: cardDetails[] = [{ name: t("wyse_label"), class:"card-img-color-tc",  imgUrl: thinImage, desc: t("wyse_desc"), url: "#/thinclient" }, { name: t("iot"), class:"card-img-color-iot", url: "#/iot", imgUrl: iotImage, desc: t("iot_desc") }];
  const cards: cardDetails[] = [{ name: t("wyse_label"), class:"card-img-color-tc",  imgUrl: thinImage, desc: t("wyse_desc"), url: "/thinclient" }];

  useEffect(() => {
        // pick default card (example: first card)
        if (cards.length > 0) {
          navigate(cards[0].url);
        }
      }, []);

  return (
    <div className="container flex-grow-1">
      <div className="row">
        <h2 className="text-left hd-txt">{t("home_h1")}</h2>
        <div className="card-group card-no-bg">
        {cards.map((card: cardDetails) => (
              <div className="card card-no-bg p-3 border-0" key={card.name}>
                <div className="card-body text-left d-flex flex-column">
                  <div className={card.class}>
                  <div className="card-image" style={{ backgroundImage: "url(" + card.imgUrl + ")" }}></div>
                  </div>
                 
                  <h5 className="card-title mt-4">{card.name}</h5>
                  <p className="card-text text-start">{card.desc}</p>
                  <div className="card-cta">
                    <a href={card.url} className="text-blue">{t("learn_more")}</a>
                  </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

export default function Home() {

  return (
    <div className="wrapper">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}